import { Modal, Space, Typography } from 'antd';
import { FC, useCallback, useMemo } from 'react';
import { FileCardGallery, useFilesUrlWithToken } from 'services';
import { useDownload } from '../../hooks/useDownload';

type FileInfoModalProps = {
  file?: FileCardGallery;
  close: () => void;
  open: boolean;
};

const { Paragraph } = Typography;

export const FileInfoModal: FC<FileInfoModalProps> = ({ file, close, open }) => {
  const { downloadFile } = useDownload();
  const { fileUrlWithToken } = useFilesUrlWithToken();

  const fileSize = useMemo(() => {
    if (file?.size !== undefined) {
      const valueInMB = parseInt(file?.size || '0', 10) / 1024 / 1024;

      return Math.round((valueInMB + Number.EPSILON) * 100) / 100;
    }
  }, [file?.size]);

  const handleOnOkay = useCallback(() => {
    if (file?.extension === 'pdf') {
      const fileUrl = fileUrlWithToken(file?.url);
      if (fileUrl) {
        window.open(fileUrl, '_blank');
      }
    } else {
      downloadFile(file?.url);
    }
  }, [downloadFile, file, fileUrlWithToken]);

  return (
    <Modal
      title="File info"
      open={open}
      centered
      width={648}
      okText={file?.extension === 'pdf' ? 'Open file' : 'Download'}
      onOk={handleOnOkay}
      cancelText="Close"
      // className={styles.modalInfo}
      onCancel={close}
    >
      <Paragraph>Name: {file?.name}</Paragraph>
      <Paragraph>
        <Space>
          File size:
          {fileSize}
          Mb
        </Space>
      </Paragraph>
      <Paragraph>File type: {file?.type}</Paragraph>
    </Modal>
  );
};
